<template>
  <div class="public-layout">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'PublicLayout'
  };
</script>
